type MessageCircleIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
  fill?: string;
};

export const MessageCircleIcon = ({ fill = 'currentColor', ...rest }: MessageCircleIconProps) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.5 7.66669C14.5023 8.5466 14.2967 9.41461 13.9 10.2C13.4296 11.1412 12.7065 11.9328 11.8116 12.4862C10.9168 13.0396 9.88549 13.3329 8.83333 13.3334C7.95342 13.3356 7.08541 13.1301 6.3 12.7334L2.5 14L3.76667 10.2C3.36995 9.41461 3.16437 8.5466 3.16667 7.66669C3.16707 6.61452 3.46041 5.58325 4.01381 4.68839C4.56722 3.79352 5.35884 3.0704 6.3 2.60002C7.08541 2.20331 7.95342 1.99772 8.83333 2.00002H9.16667C10.5562 2.07668 11.8687 2.66319 12.8528 3.64726C13.8368 4.63132 14.4233 5.94379 14.5 7.33335V7.66669Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
